import _objectSpread from "/root/workspace/ubq-h5_build/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
//
//
//
//
//
//
import { mapGetters } from 'vuex';
export default {
  name: 'SkinChange',
  data: function data() {
    return {};
  },
  computed: _objectSpread({}, mapGetters(['skinChange']))
};